import React from "react";
import { Grid } from "semantic-ui-react";
import { DateTime } from "luxon";
import { Link } from "../../../shims/useNavigate";

import FolderVector from "../../../assets/FolderVector";

import { Group } from "../../../types/types";

interface FavouriteGroupCardProps {
	group: Group;
}

const FavouriteGroupCard = ({ group }: FavouriteGroupCardProps) => {
	const datetime = DateTime.fromISO(group.inserted_at);

	return (
		<Grid verticalAlign="middle">
			<Link to={`/groups/${group.id}/epc-data`}>
				<Grid.Column>
					<FolderVector />
				</Grid.Column>
				<Grid.Column width={12}>
					<Grid.Row>
						<Grid.Column>{group.name}</Grid.Column>
						<Grid.Column>
							<p style={{ opacity: 0.5 }}>{datetime.toRelative()}</p>
						</Grid.Column>
					</Grid.Row>
				</Grid.Column>
			</Link>
		</Grid>
	);
};

export default FavouriteGroupCard;
